import { PlusCircleFilled } from '@ant-design/icons'
import { useLazyQuery } from '@apollo/client'
import { Button, Col, Drawer, List, Typography } from 'antd'
import { useState } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { DEMANDE_BY_EQUIPEMENT } from '../../apollo/query/demande.query'
import { useSmallScreen } from '../../lib/hooks'
import { D4_Demande } from '../../types'
import DemandeExpressForm from './DemandeExpressForm'

/**
 * Todo refacto
 */

const StyledIcon = styled(PlusCircleFilled)`
  font-size: 42px !important;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

const DemandeExpress = () => {
  const smallScreen = useSmallScreen()
  const [visible, setVisible] = useState(false)
  const { push } = useHistory()

  const [fetchDemandes, { data: demandes, loading: demandesLoading }] = useLazyQuery<
    { demandes: D4_Demande[] },
    DemandeDetailVars
  >(DEMANDE_BY_EQUIPEMENT, { fetchPolicy: 'network-only' })

  const onValuesChanges = async ({ name, infos }: FormValuesChanges) => {
    const { forms } = infos
    if (name === 'selectMultiSources') {
      await fetchDemandes({
        variables: {
          contextId: forms.selectMultiSources.getFieldValue('coproprieteId') ?? -1,
          batimentId: forms.selectMultiSources.getFieldValue('batiment') ?? -1,
          equipementId: forms.selectMultiSources.getFieldValue('equipement') ?? -1,
        },
      })
    }
  }
  return (
    <>
      <Drawer
        title="Demande Express"
        visible={visible}
        onClose={() => setVisible(false)}
        width={smallScreen ? '100%' : '70%'}
        destroyOnClose
      >
        <DemandeExpressForm
          onValuesChange={onValuesChanges}
          handleClose={() => setVisible(false)}
          withList
          withPersonneDescription
          withTextInput
          withSocieteDescription
        >
          <Col xs={24} sm={12} md={8}>
            <List
              loading={demandesLoading}
              bordered
              dataSource={demandes?.demandes ?? []}
              header="Demandes en cours"
              style={{ backgroundColor: 'white' }}
              renderItem={(item) => (
                <List.Item onClick={() => push({ search: `?demandeId=${item.id}` })}>
                  <Typography.Text style={{ cursor: 'pointer' }}>{item.description}</Typography.Text>
                </List.Item>
              )}
            />
          </Col>
        </DemandeExpressForm>
      </Drawer>
      <Button
        onClick={() => setVisible(!visible)}
        style={{ position: 'fixed', bottom: 10, right: 20 }}
        size="large"
        shape="circle"
        icon={<StyledIcon />}
        type="link"
      />
    </>
  )
}

export default DemandeExpress
